import type { ReactNode } from 'react';

export const symbol_margin: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Zm162 162q11-11 11-28t-11-28q-11-11-28-11t-28 11q-11 11-11 28t11 28q11 11 28 11t28-11Zm138 11q17 0 28.5-11.21T520-646q0-16.58-11.5-27.79T480-685q-16 0-27 11.5T442-646q0 16 10.92 27.5Q463.85-607 480-607Zm195-11q11-11 11-28t-11-28q-11-11-28-11t-28 11q-11 11-11 28t11 28q11 11 28 11t28-11Zm0 166q11-11 11-28t-11-28q-11-11-28-11t-28 11q-11 11-11 28t11 28q11 11 28 11t28-11Zm-195 11q17 0 28.5-11.21T520-480q0-16.58-11.5-27.79T480-519q-16 0-27 11.5T442-480q0 16 10.92 27.5Q463.85-441 480-441Zm-138-11q11-11 11-28t-11-28q-11-11-28-11t-28 11q-11 11-11 28t11 28q11 11 28 11t28-11Z"
		/>
	</svg>
);
